// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.param-value {
  background-color: var(--colorBgLevel4);
}

.logic-value {
  display: block;
}

.parsed-param {
  display: inline-flex;
  padding: 0 0.3em;
  max-width: 100%;
  text-overflow: ellipsis;
  border-radius: 3px;
  overflow: hidden;
}

.simple-param-block {
  padding: 0;
  display: inline;
}
.simple-param-block-body {
  padding: 0;
  display: inline;
}

.param-block {
  padding-left: 5px;
}
.param-block-body {
  padding-left: 20px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
